import _ from 'lodash';
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {trudWardsDict} from '../store/reducers/dicts';

export default function useWardDict() {
    // Ward list from redux
    const trudWardList = useSelector(trudWardsDict);

    const [wardDict, setWardDict] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        setWardDict(_.sortBy(trudWardList, ['wardName']));
        setLoading(false);
    }, [trudWardList]);

    return [wardDict, loading];
}